import { Helmet } from "react-helmet-async";
import { useLanguage } from "@/contexts/LanguageContext";
import { createOrganizationSchema } from "@/utils/structuredData";

/** Organization JSON-LD on every page — helps crawlers that only hit a subset of routes. */
const GlobalStructuredData = () => {
  const { language } = useLanguage();
  const lang = language === "en" ? "en" : "pt";

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(createOrganizationSchema(lang))}
      </script>
    </Helmet>
  );
};

export default GlobalStructuredData;
